export default "__VITE_ASSET__0MrD4Yt1__"